import { Typography, TypographyProps } from '@material-ui/core'
import { useAppSelector } from 'store/configureStore'
import { bomItemDimensionsSelector } from '../store/selectors/bomItemDimensionsSelector'

export const PartTypeDimensionSummary = ({
  bomItemId,
  typographyProps,
}: {
  bomItemId: string
  typographyProps?: TypographyProps
}) => {
  const dimensions = useAppSelector(bomItemDimensionsSelector(bomItemId))

  if (!dimensions) {
    return null
  }

  return (
    <Typography variant="body2" color="textPrimary" {...typographyProps}>
      {`${dimensions}`}
    </Typography>
  )
}
